import {routes} from './produto.routes';
import ProdutoListController from "./directory/directory.controller";
import ProdutoService from "./produto.service";
import ProdutoDetailsController from "./details/details.controller";
import ProdutoCreateProdutoController from "./new/new.controller";

export default angular.module('app.produto', [])
  .config(routes)
  .controller('ProdutoListController', ProdutoListController)
  .service('ProdutoService', ProdutoService)
  .controller('ProdutoDetailsController', ProdutoDetailsController)
  .controller('ProdutoCreateProdutoController', ProdutoCreateProdutoController)
  .name;
